// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checklist {
  background: #f3f4f6;
}
.checklist__head {
  display: flex;
}
.checklist__head__button {
  display: flex;
  margin-left: auto;
}
.checklist__head__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.checklist__dates {
  display: flex;
  margin-top: 20px;
  width: 400px;
}
.checklist__arrows__left {
  margin-right: 10px;
}
.checklist__arrows__right {
  margin-left: 10px;
}
.checklist__today-button {
  margin-left: 10px;
  margin-right: 10px;
}
.checklist__board {
  margin-top: 30px;
}
.checklist__board__row {
  display: flex;
  justify-content: space-between;
}
.checklist__board__column-left {
  flex: 0.32 1;
}
.checklist__board__column-center {
  flex: 0.32 1;
}
.checklist__board__column-right {
  flex: 0.32 1;
}
.checklist__board__head {
  height: 50px;
  border-radius: 8px;
  padding: 15px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
}
.checklist__board__span {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
}
.checklist__board__span-grey {
  color: #999999;
}
.checklist__board__span-red {
  color: #e47c77;
}
.checklist__board__span-green {
  color: #49ae9e;
}
.checklist__board__card {
  margin-top: 10px;
  background: #ffffff;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
}
.checklist__board__card__head {
  display: flex;
}
.checklist__board__card__action {
  margin-left: auto;
  padding: 15px;
  cursor: pointer;
}
.checklist__board__card__texts {
  flex: 1 1;
  margin-left: 5px;
  padding: 15px;
}
.checklist__board__card__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}
.checklist__board__card__schedule {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #868686;
}
.checklist__board__card__assignees-row {
  display: flex;
  padding-top: 20px;
}
.checklist__board__card__assignees {
  margin-left: auto;
}
.checklist__modal-profile {
  display: flex;
}
.checklist__modal-profile__image {
  margin-right: 10px;
  border-radius: 50%;
  height: 32px;
  width: 32px;
  object-fit: cover;
  float: right;
}
.checklist__modal-profile__image-ext {
  margin-right: 10px;
  position: relative;
  border-radius: 50%;
  height: 32px;
  width: 32px;
  object-fit: cover;
  float: right;
  background: #333333;
  z-index: 100;
  border: 2px solid #ffffff;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  padding-top: 5px;
  align-items: center;
  text-align: center;
  color: #ffffff;
}
.checklist__popup__icon {
  cursor: pointer;
  padding-right: 10px;
  padding-left: 10px;
}
.checklist__popup__resend-invite {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  cursor: pointer;
  padding-top: 4px;
}
.checklist__popup__delete-invite {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  cursor: pointer;
  padding-top: 12px;
}

.images-wrapper {
  width: 220px;
}
.images-wrapper img {
  position: relative;
  border: solid white 2px;
}
.images-wrapper :nth-child(5) {
  z-index: 0;
  left: 100px;
}
.images-wrapper :nth-child(4) {
  z-index: 1;
  left: 75px;
}
.images-wrapper :nth-child(3) {
  z-index: 2;
  left: 50px;
}
.images-wrapper :nth-child(2) {
  z-index: 3;
  left: 25px;
}
.images-wrapper :nth-child(1) {
  z-index: 4;
  left: 0px;
}

.checklist-toast {
  text-align: center;
  display: flex;
  align-items: center;
}
.checklist-toast__text {
  margin-left: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/screens/checklist/checklist.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;AACI;EACI,aAAA;AACR;AACQ;EACI,aAAA;EACA,iBAAA;AACZ;AAEQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAZ;AAII;EACI,aAAA;EACA,gBAAA;EACA,YAAA;AAFR;AASQ;EACI,kBAAA;AAPZ;AAUQ;EACI,iBAAA;AARZ;AAYI;EACI,iBAAA;EACA,kBAAA;AAVR;AAaI;EACI,gBAAA;AAXR;AAaQ;EACI,aAAA;EACA,8BAAA;AAXZ;AAcQ;EACI,YAAA;AAZZ;AAeQ;EACI,YAAA;AAbZ;AAgBQ;EACI,YAAA;AAdZ;AAiBQ;EACI,YAAA;EACA,kBAAA;EACA,aAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhBZ;AAmBQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAjBZ;AAoBQ;EACI,cAAA;AAlBZ;AAqBQ;EACI,cAAA;AAnBZ;AAsBQ;EACI,cAAA;AApBZ;AAuBQ;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,4CAAA;AArBZ;AAuBY;EACI,aAAA;AArBhB;AAwBY;EACI,iBAAA;EACA,aAAA;EACA,eAAA;AAtBhB;AAyBY;EACI,SAAA;EACA,gBAAA;EACA,aAAA;AAvBhB;AA0BY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxBhB;AA2BY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAzBhB;AA4BY;EACI,aAAA;EACA,iBAAA;AA1BhB;AA6BY;EACI,iBAAA;AA3BhB;AAgCI;EACI,aAAA;AA9BR;AAgCQ;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AA9BZ;AAiCQ;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAhCZ;AAqCQ;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;AAnCZ;AAsCQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AApCZ;AAuCQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AArCZ;;AA4CA;EACI,YAAA;AAzCJ;AA2CI;EAEI,kBAAA;EACA,uBAAA;AA1CR;AA8CQ;EACI,UAAA;EACA,WAAA;AA5CZ;AA0CQ;EACI,UAAA;EACA,UAAA;AAxCZ;AAsCQ;EACI,UAAA;EACA,UAAA;AApCZ;AAkCQ;EACI,UAAA;EACA,UAAA;AAhCZ;AA8BQ;EACI,UAAA;EACA,SAAA;AA5BZ;;AAiCA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AA9BJ;AAgCI;EACI,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AA9BR","sourcesContent":[".checklist {\n    background: #f3f4f6;\n\n    &__head {\n        display: flex;\n\n        &__button {\n            display: flex;\n            margin-left: auto;\n        }\n\n        &__text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #333333;\n        }\n    }\n\n    &__dates {\n        display: flex;\n        margin-top: 20px;\n        width: 400px;\n    }\n\n    &__input {\n    }\n\n    &__arrows {\n        &__left {\n            margin-right: 10px;\n        }\n\n        &__right {\n            margin-left: 10px;\n        }\n    }\n\n    &__today-button {\n        margin-left: 10px;\n        margin-right: 10px;\n    }\n\n    &__board {\n        margin-top: 30px;\n\n        &__row {\n            display: flex;\n            justify-content: space-between;\n        }\n\n        &__column-left {\n            flex: 0.32;\n        }\n\n        &__column-center {\n            flex: 0.32;\n        }\n\n        &__column-right {\n            flex: 0.32;\n        }\n\n        &__head {\n            height: 50px;\n            border-radius: 8px;\n            padding: 15px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 18px;\n            line-height: 24px;\n            color: #333333;\n        }\n\n        &__span {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 18px;\n            line-height: 26px;\n        }\n\n        &__span-grey {\n            color: #999999;\n        }\n\n        &__span-red {\n            color: #e47c77;\n        }\n\n        &__span-green {\n            color: #49ae9e;\n        }\n\n        &__card {\n            margin-top: 10px;\n            background: #ffffff;\n            border-radius: 8px;\n            cursor: pointer;\n            box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n\n            &__head {\n                display: flex;\n            }\n\n            &__action {\n                margin-left: auto;\n                padding: 15px;\n                cursor: pointer;\n            }\n\n            &__texts {\n                flex: 1;\n                margin-left: 5px;\n                padding: 15px;\n            }\n\n            &__text {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 22px;\n                color: #333333;\n            }\n\n            &__schedule {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 18px;\n                color: #868686;\n            }\n\n            &__assignees-row {\n                display: flex;\n                padding-top: 20px;\n            }\n\n            &__assignees {\n                margin-left: auto;\n            }\n        }\n    }\n\n    &__modal-profile {\n        display: flex;\n\n        &__image {\n            margin-right: 10px;\n            border-radius: 50%;\n            height: 32px;\n            width: 32px;\n            object-fit: cover;\n            float: right;\n        }\n\n        &__image-ext {\n            margin-right: 10px;\n            position: relative;\n            border-radius: 50%;\n            height: 32px;\n            width: 32px;\n            object-fit: cover;\n            float: right;\n            background: #333333;\n            z-index: 100;\n            border: 2px solid #ffffff;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            padding-top: 5px;\n            align-items: center;\n            text-align: center;\n            color: #ffffff;\n        }\n    }\n\n    &__popup {\n        &__icon {\n            cursor: pointer;\n            padding-right: 10px;\n            padding-left: 10px;\n        }\n\n        &__resend-invite {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #333333;\n            cursor: pointer;\n            padding-top: 4px;\n        }\n\n        &__delete-invite {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #333333;\n            cursor: pointer;\n            padding-top: 12px;\n        }\n    }\n}\n\n$maxImagesNumber: 5;\n\n.images-wrapper {\n    width: 220px;\n\n    img {\n        // display:inline-block;\n        position: relative;\n        border: solid white 2px;\n    }\n\n    @for $i from $maxImagesNumber through 1 {\n        :nth-child(#{ $i }) {\n            z-index: #{$maxImagesNumber - $i};\n            left: #{($i - 1) * 25}px;\n        }\n    }\n}\n\n.checklist-toast {\n    text-align: center;\n    display: flex;\n    align-items: center;\n\n    &__text {\n        margin-left: 10px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        text-align: center;\n        color: #ffffff;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
